'use es6';

import { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import UIBox from 'UIComponents/layout/UIBox';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIcon from 'UIComponents/icon/UIIcon';
import H4 from 'UIComponents/elements/headings/H4';
import UITruncateString from 'UIComponents/text/UITruncateString';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import UITourStep from 'ui-shepherd-react/tour/UITourStep';
import UITourNextButton from 'ui-shepherd-react/button/UITourNextButton';
import UICloseButton from 'UIComponents/button/UICloseButton';
import UIAlert from 'UIComponents/alert/UIAlert';
import UILink from 'UIComponents/link/UILink';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { connect } from 'react-redux';
import { getShouldUseResponsiveBreakpoints } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import { getIsReadOnlyMode } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { getIsUngatedForModuleVersioning } from 'ContentEditorUI/redux/selectors/authSelectors';
import { getModuleVersions, getModuleHasUpgradeAvailable } from 'ContentEditorUI/redux/selectors/moduleVersionsSelectors';
import { getFetchModuleVersionsRequest } from 'ContentEditorUI/redux/selectors/requestStatesSelectors';
import { fetchModuleVersions } from 'ContentEditorUI/redux/actions/moduleVersionsActions';
import { requestSucceeded } from 'redux-request-state/util/requestStateCheckers';
import ContentRoutes from 'ContentUtils/Routes';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const mapStateToProps = state => ({
  shouldUseResponsiveBreakpoints: getShouldUseResponsiveBreakpoints(state),
  isReadOnlyMode: getIsReadOnlyMode(state),
  isUngatedForModuleVersioning: getIsUngatedForModuleVersioning(state),
  moduleVersions: getModuleVersions(state),
  moduleVersionsRequestStatus: getFetchModuleVersionsRequest(state),
  modulehasUpgradeAvailable: getModuleHasUpgradeAvailable(state)
});
const mapDispatchToProps = {
  fetchModuleVersions
};
class SidebarHeaderContainer extends Component {
  componentDidMount() {
    const {
      isUngatedForModuleVersioning,
      moduleVersionsRequestStatus,
      moduleSchema
    } = this.props;
    const isDefaultModule = moduleSchema && moduleSchema.default;
    if (isDefaultModule && isUngatedForModuleVersioning && !requestSucceeded(moduleVersionsRequestStatus)) {
      this.props.fetchModuleVersions();
    }
  }
  renderUpgradeAlert() {
    return /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(UIAlert, {
        className: "m-x-6 m-y-4",
        type: "info",
        style: {
          zIndex: 9
        },
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "moduleVersioning.moduleFormAlert_jsx",
          options: {
            external: true,
            href: ContentRoutes.settings('themes')
          },
          elements: {
            Link: UILink
          }
        })
      })
    });
  }
  render() {
    const {
      backLink,
      headerLabel,
      breadcrumbs,
      closePatagoniaSidebarCallback,
      modulehasUpgradeAvailable
    } = this.props;
    const {
      tour
    } = this.context;
    const classes = "p-x-5 " + (modulehasUpgradeAvailable ? 'sidebar-header-with-module-upgrade-alert' : breadcrumbs ? 'sidebar-header-with-breadcrumbs' : 'sidebar-header');
    const headerContainerContents = /*#__PURE__*/_jsxs(Fragment, {
      children: [breadcrumbs, /*#__PURE__*/_jsxs(UIFlex, {
        className: classes,
        align: "center",
        justify: "between",
        children: [/*#__PURE__*/_jsx(UIBox, {
          className: "sidebar-header-label",
          children: /*#__PURE__*/_jsxs(UIFlex, {
            direction: "column",
            align: "start",
            children: [backLink && /*#__PURE__*/_jsxs("div", {
              className: "p-bottom-2",
              children: [/*#__PURE__*/_jsx(UIIcon, {
                name: "left"
              }), " ", backLink]
            }), /*#__PURE__*/_jsx(H4, {
              className: "m-all-0",
              children: /*#__PURE__*/_jsx(UITruncateString, {
                children: headerLabel
              })
            })]
          })
        }), /*#__PURE__*/_jsx(UICloseButton, {
          className: "patagonia-sidebar-header-close-button",
          size: "medium",
          onClick: () => closePatagoniaSidebarCallback(),
          "data-selenium": "save-and-close-sidebar"
        })]
      }), modulehasUpgradeAvailable && this.renderUpgradeAlert()]
    });
    if (tour) {
      return /*#__PURE__*/_jsx(UITourStep, {
        stepKey: "building",
        showCloseButton: true,
        showSteps: true,
        attachTo: ".sidebar-header",
        placement: "right",
        content: {
          header: /*#__PURE__*/_jsx("h4", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "baymaxShepherd.building.header"
            })
          }),
          body: /*#__PURE__*/_jsxs(Fragment, {
            children: [/*#__PURE__*/_jsx("span", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "baymaxShepherd.building.body"
              })
            }), /*#__PURE__*/_jsxs("ul", {
              children: [/*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                  message: "baymaxShepherd.building.bodyListItemOneHtml"
                })
              }), /*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                  message: "baymaxShepherd.building.bodyListItemTwoHtml"
                })
              }), /*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                  message: "baymaxShepherd.building.bodyListItemThreeHtml"
                })
              })]
            })]
          }),
          footer: /*#__PURE__*/_jsx(UIButtonWrapper, {
            children: /*#__PURE__*/_jsx(UITourNextButton, {
              use: "primary",
              size: "small",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "baymaxShepherd.next"
              })
            })
          })
        },
        children: headerContainerContents
      });
    }
    return headerContainerContents;
  }
}
SidebarHeaderContainer.contextType = TourContext;
SidebarHeaderContainer.propTypes = {
  backLink: PropTypes.node,
  headerLabel: PropTypes.node.isRequired,
  shouldUseResponsiveBreakpoints: PropTypes.bool.isRequired,
  isReadOnlyMode: PropTypes.bool.isRequired,
  breadcrumbs: PropTypes.node,
  closePatagoniaSidebarCallback: PropTypes.func,
  fetchModuleVersions: PropTypes.func.isRequired,
  moduleVersionsRequestStatus: PropTypes.object.isRequired,
  isUngatedForModuleVersioning: PropTypes.bool.isRequired,
  moduleSchema: PropTypes.object,
  modulehasUpgradeAvailable: PropTypes.bool
};
export default connect(mapStateToProps, mapDispatchToProps)(SidebarHeaderContainer);